import { Box } from '@mui/material'

interface IFormDivisor {
  marginTop?: string
  marginBottom?: string
}

const FormDivisor = ({ marginTop = '5px', marginBottom = '1rem' }: IFormDivisor) => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '1px',
        backgroundColor: '#E4E4E4',
        marginTop: marginTop,
        marginBottom: marginBottom,
      }}
    />
  )
}

export default FormDivisor
